// Port of api/fuel/app/classes/insights/plays/weight.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'weight',
    insight: false,
    detail: false,
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_plays()) return {}

        var count = vars.count || 'plays'
        var weights = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        var range = this.get_period_date_range(type, owner, filter)
        var players = filter.players || 0
        var sqlCount = players ? ' AND p.play_players = ' + players : ''

        if (count === 'plays') {

            var playedIndex = Util.queryFast(
                'SELECT SUM(p.play_count) AS c, g.game_weight_avg AS w' +
                ' FROM play p, game g' +
                ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
                ' AND p.play_date >= ' + range.start +
                ' AND p.play_date <= ' + (range.end - 1) +
                ' AND p.game_id = g.game_id' +
                sqlCount +
                ' GROUP BY p.game_id'
            )

            for (var i = 0; i < playedIndex.length; i++) {
                var w = parseFloat(playedIndex[i].w)
                var c = parseInt(playedIndex[i].c, 10)

                if (w <= 1.24) weights[0] += c
                else if (w <= 1.49) weights[1] += c
                else if (w <= 1.74) weights[2] += c
                else if (w <= 1.99) weights[3] += c
                else if (w <= 2.24) weights[4] += c
                else if (w <= 2.49) weights[5] += c
                else if (w <= 2.74) weights[6] += c
                else if (w <= 2.99) weights[7] += c
                else if (w <= 3.24) weights[8] += c
                else if (w <= 3.49) weights[9] += c
                else if (w <= 3.74) weights[10] += c
                else if (w <= 3.99) weights[11] += c
                else if (w <= 4.24) weights[12] += c
                else if (w <= 4.49) weights[13] += c
                else if (w <= 4.74) weights[14] += c
                else if (w <= 5) weights[15] += c
            }

        }

        return {
            weights: weights
        }

    }
})
